/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Log } from '../logging/Log';

export class MessageService {
    public static readonly CCB_OVERRIDDEN_SWITCHES: string =
        'KaveriApp.BackdoorEntry.getCcbOverriddenSwitches';

    public static readonly CCB_SWITCH_PARTNER: string =
        'KaveriApp.BackdoorEntry.getCcbSwitchPartner';

    public static readonly CCB_SWITCH_VERSION: string =
        'KaveriApp.BackdoorEntry.getCcbSwitchVersion';

    public static readonly CLOSE_APPLICATION: string = 'KaveriApp.DeviceModel.closeApplication';

    public static readonly DISABLE_SCREENSAVER: string = 'KaveriApp.DeviceModel.disableScreenSaver';

    public static readonly ENABLE_SCREENSAVER: string = 'KaveriApp.DeviceModel.enableScreenSaver';

    public static readonly GET_APP_ENVIRONMENT: string = 'KaveriApp.DeviceModel.getAppEnvironment';

    public static readonly GET_FLAVOUR: string = 'KaveriApp.DeviceModel.getFlavour';

    public static readonly GET_SYSTEM_INFO: string = 'KaveriApp.DeviceModel.getSystemInfo';

    public static readonly GET_TV_PROPERTIES: string = 'KaveriApp.DeviceModel.getTVProperties';

    public static readonly GET_TIVO_SETTINGS: string = 'KaveriApp.DeviceModel.getTiVoSettings';

    public static readonly LAUNCH_SYSTEM_SETTING: string =
        'KaveriApp.DeviceModel.launchSystemSetting';

    public static readonly RESTART_APPLICATION: string = 'KaveriApp.DeviceModel.restartApplication';

    private readonly payload: Object = {};

    private readonly serviceName: string = '';

    private serviceTimeoutId: any = null;

    private readonly TAG = 'MessageService';

    public constructor(serviceName, serviceArgs?) {
        this.serviceName = serviceName;
        this.payload = {
            type: 'messageServiceRequest',
            serviceName,
            serviceArgs,
        };
    }

    public getResponse = () => {
        return new Promise((resolve, reject) => {
            const cleanup = () => {
                window.removeEventListener('message', handler);
                clearTimeout(this.serviceTimeoutId);
            };

            const handler = (event: MessageEvent) => {
                const data = event?.data;
                if (window.self === window.top && !(window as any).__IS_VEGA_OS_PLATFORM__) {
                    cleanup();
                    return resolve(true);
                }

                if (
                    data.type !== 'messageServiceResponse' ||
                    data.serviceName !== this.serviceName
                ) {
                    return;
                }

                if (
                    data.type === 'messageServiceResponse' &&
                    data.serviceName === this.serviceName
                ) {
                    cleanup();
                    return resolve(data.response);
                }
            };

            window.addEventListener('message', handler);

            this.serviceTimeoutId = setTimeout(() => {
                window.removeEventListener('message', handler);
                Log.e(this.TAG, `Service timeout ${this.serviceName}`);
                return reject(new Error(`Service timeout ${this.serviceName}`));
            }, 3000);

            if ((window as any).__IS_VEGA_OS_PLATFORM__) {
                (window as any).ReactNativeWebView.postMessage(JSON.stringify(this.payload));
            } else {
                window.parent.postMessage(this.payload, '*');
            }
        });
    };
}
